module.exports = __webpack_public_path__ + "images/help/icon-plane-3f19828bed3869bca9c0bb9cf06d9ff6.png";